"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginSelector = loginSelector;
exports.phoneSelector = phoneSelector;
function phoneSelector(state) {
  return state.view.data.phone;
}
function loginSelector(state) {
  return state.login;
}